import {useCallback, useEffect, useRef, useState} from 'react';
import * as store from '@/store';
import LoadingPng from '@/assets/img/loading.png';
import {ServerConfig} from '@/config/routers';

import {utils} from '@/kuTools/sdk/utils';
import type {IShowFlowCardDialogProps} from '@/kuTools/types';
import styles from './index.module.scss';

enum STATE_TYPE {
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success',
}

const FlowCardDialog = (props: IShowFlowCardDialogProps) => {
    const {title, jsonContent = [], target} = props;

    const [state, setState] = useState(STATE_TYPE.SUCCESS);
    const flowRef = useRef(null);

    const getGitCaseUrl = useCallback(async () => {
        const docGuid = store.getData(store.KEYS.CUR_DOCUMENT)?.docGuid || '';

        try {
            setState(STATE_TYPE.LOADING);
            const res = await utils.ksRequest({
                url: `${ServerConfig.wiki}/so/card/common?docGuid=${docGuid}`,
                method: 'post',
                data: {
                    target,
                },
            });
            setState(STATE_TYPE.SUCCESS);

            const url = res?.value;
            window.flow?.linkRecognize?.renderCard?.({
                container: flowRef.current!,
                url,
            });
        } catch (error) {
            setState(STATE_TYPE.ERROR);
            console.error(error);
        }
    }, [target]);

    useEffect(() => {
        getGitCaseUrl();
    }, [getGitCaseUrl]);

    const handleLink = (url: string) => {
        window.open(url);
    };

    const handleRetry = () => {
        getGitCaseUrl();
    };

    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            <div className={styles.remind}>
                {jsonContent.map((item, i) => {
                    if (item.type === 'link') {
                        return (
                            <span
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                                className={styles.link}
                                onClick={() => handleLink(item.href)}
                            >
                                {item.text}
                            </span>
                        );
                    }
                    // eslint-disable-next-line react/no-array-index-key
                    return <span key={i}>{item.text}</span>;
                })}
            </div>
            <div className={styles.content}>
                {state === STATE_TYPE.LOADING && <img className={styles.loading} src={LoadingPng} />}
                {
                    state === STATE_TYPE.ERROR &&
                        <div className={styles.error}>
                            <span>加载失败</span>
                            <span
                                className={styles.retry}
                                onClick={handleRetry}
                            >
                                点击重试
                            </span>
                        </div>
                }
                {
                    state === STATE_TYPE.SUCCESS &&
                        <div className={styles.success}>
                            <div ref={flowRef}></div>
                        </div>
                }
            </div>
        </div>
    );
};

export default FlowCardDialog;
